// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"347":"e2f947d4","499":"d665706b","502":"e2f947d4","531":"6682c045","618":"eb73bd6d","747":"21eac4fc","843":"e2f947d4"}[chunkId] + ".chunk.css";
};